export const activitiesActionTypes = {
	GET_ACTIVITIES: "GET_ACTIVITIES",
	GET_ANNOUNCEMENTS: "GET_ANNOUNCEMENTS",
};
